const ADD_ELEMENT = 'ADD_ELEMENT';
const UPDATE_ELEMENT = 'UPDATE_ELEMENT';
const DELETE_ELEMENT = 'DELETE_ELEMENT';
const LOAD_FORM_JSON_TXT = 'LOAD_FORM_JSON_TXT';
const LOAD_FORM_JSON_FILE = 'LOAD_FORM_JSON_FILE';

export default {
  ADD_ELEMENT,
  UPDATE_ELEMENT,
  DELETE_ELEMENT,
  LOAD_FORM_JSON_TXT,
  LOAD_FORM_JSON_FILE
}
